import { createCpmsBoUserSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-user.slice';

import { cpmsBoUserApi } from './cpms-bo-user.service';

export const cpmsBoUserSlice = createCpmsBoUserSlice({ cpmsBoUserApi });
